import React from 'react';
import cx from 'classnames';

import Button from 'components/Button';
import TextWithIcon from 'components/TextWithIcon';
import CoachingConstants from 'coaching/CoachingConstants';

type Props = {
  className?: string;
  eventKey?: string;
  isCoach?: boolean;
};

export default function CoachingGetHelpButton({ className, eventKey, isCoach }: Props) {
  const linkProps = isCoach
    ? {
        to: CoachingConstants.COACHING_COACH_HELP_ROUTE,
        target: '_blank',
      }
    : {
        to: CoachingConstants.COACHING_HELP_ROUTE,
        target: '_blank',
      };

  return (
    <Button className="CoachingHelpButton" eventKey={eventKey} {...linkProps}>
      <TextWithIcon
        className={cx('CoachingHelpButton-text', className)}
        icon="question-circle"
        iconSize="medium"
        size="small">
        Get help
      </TextWithIcon>
    </Button>
  );
}
